var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-md-6" }, [
      _c(
        "div",
        { staticClass: "client_card" },
        [
          _c("clientCard", {
            ref: "clientForm",
            attrs: {
              client: _vm.client,
              search: false,
              phones: (_vm.client && _vm.client.phones) || null,
              updateClient: _vm.updateClient,
            },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-md-6" }, [
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.order.comment,
            expression: "order.comment",
          },
        ],
        staticClass: "form-control mb-1",
        attrs: { placeholder: "Комментарий к заявке" },
        domProps: { value: _vm.order.comment },
        on: {
          input: function ($event) {
            if ($event.target.composing) return
            _vm.$set(_vm.order, "comment", $event.target.value)
          },
        },
      }),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.order.address,
            expression: "order.address",
          },
        ],
        staticClass: "form-control",
        attrs: { placeholder: "Адрес" },
        domProps: { value: _vm.order.address },
        on: {
          input: function ($event) {
            if ($event.target.composing) return
            _vm.$set(_vm.order, "address", $event.target.value)
          },
        },
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "form-group" },
        [
          _c("label", { attrs: { for: "" } }, [
            _vm._v("Дата планируемой доставки"),
          ]),
          _vm._v(" "),
          _c("datetime", {
            attrs: {
              "input-class": "form-control",
              type: "date",
              "minute-step": 60,
              format: "dd.MM.yyyy (cccc)",
              auto: true,
              "min-datetime": _vm.minDateSelect,
              "max-datetime": _vm.maxDateSelect,
            },
            model: {
              value: _vm.deliveryDate,
              callback: function ($$v) {
                _vm.deliveryDate = $$v
              },
              expression: "deliveryDate",
            },
          }),
        ],
        1
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-md-9" },
      [
        _c("smallFormSelectDrugsWithPrice", {
          ref: "drugsSelected",
          attrs: { drugsUpdated: _vm.drugsUpdated },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "col-md-3 price_fields" }, [
      _c("p", { staticClass: "text-right" }, [_vm._v("Стоимость препаратов")]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.figures.totalPrice,
            expression: "figures.totalPrice",
          },
        ],
        staticClass: "form-control",
        attrs: { disabled: "" },
        domProps: { value: _vm.figures.totalPrice },
        on: {
          input: function ($event) {
            if ($event.target.composing) return
            _vm.$set(_vm.figures, "totalPrice", $event.target.value)
          },
        },
      }),
      _vm._v(" "),
      _vm.rates
        ? _c("div", [
            _c("p", { staticClass: "text-right" }, [_vm._v("Кросс курс")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.rates[_vm.exportCurrencyId],
                  expression: "rates[exportCurrencyId]",
                },
              ],
              staticClass: "form-control",
              attrs: { disabled: "" },
              domProps: { value: _vm.rates[_vm.exportCurrencyId] },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.rates, _vm.exportCurrencyId, $event.target.value)
                },
              },
            }),
            _vm._v(" "),
            _c("p", { staticClass: "text-right" }, [
              _vm._v("Просчетная стоимость"),
            ]),
            _vm._v(" "),
            _c("input", {
              staticClass: "form-control",
              attrs: { disabled: "" },
              domProps: {
                value:
                  Math.round(
                    _vm.figures.totalPrice *
                      _vm.rates[_vm.exportCurrencyId] *
                      10
                  ) / 10,
              },
            }),
          ])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "col-md-12 text-right mt-2" },
      [
        _c(
          "vue-ladda",
          {
            attrs: {
              "button-class": "btn btn-success",
              "data-style": "zoom-in",
              loading: _vm.loading,
            },
            on: { click: _vm.createNewOrder },
          },
          [_vm._v("Создать заявку\n    ")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }